import {clsx} from 'clsx'
import type {ComponentPropsWithoutRef, ElementType, ReactNode} from 'react'

import styles from './PullRequestHeaderTabNav.module.css'

interface TabNavProps extends ComponentPropsWithoutRef<'nav'> {
  'aria-label': string
  children?: ReactNode
}

function TabNavRoot({children, className, ...rest}: TabNavProps) {
  return (
    <nav className={clsx(styles.TabNav, className)} {...rest}>
      <div className={styles.TabNavList}>{children}</div>
    </nav>
  )
}
TabNavRoot.displayName = 'TabNav'

type TabNavLinkOwnProps = {
  selected?: boolean
  className?: string
  children?: ReactNode
}

type TabNavLinkProps<As extends ElementType> = TabNavLinkOwnProps & {as?: As} & Omit<
    ComponentPropsWithoutRef<As>,
    keyof TabNavLinkOwnProps | 'as'
  >

function TabNavLink<As extends ElementType = 'a'>({as, selected, className, children, ...rest}: TabNavLinkProps<As>) {
  const Component = as ?? 'a'
  return (
    <Component
      aria-current={selected ? 'page' : undefined}
      className={clsx(styles.TabNavLink, selected && styles.selected, className)}
      {...rest}
    >
      {children}
    </Component>
  )
}
TabNavLink.displayName = 'TabNav.Link'

export const TabNav = Object.assign(TabNavRoot, {Link: TabNavLink})
